// extracted by mini-css-extract-plugin
module.exports = {"item":"headerItem_item__4QUBk","item2":"headerItem_item2__ve2cF","cartCounter":"headerItem_cartCounter__Knnv0"};